import React from 'react';
import { useCartItems } from '../../hooks/useCart';
import { usePreferences } from '../../hooks/usePreferences';
import { pluralize } from './pluralize';
import { ShoppingBagNotification } from './ShoppingBagNotification';

export const PersonalizationRequiredNotification: React.FC = () => {
  const { personalizationRequiredItems } = useCartItems();
  const { personalizationRequiredNotifications, setPreference } = usePreferences();

  if (personalizationRequiredItems.length === 0) return null;
  if (!personalizationRequiredNotifications) return null;

  return (
    <ShoppingBagNotification
      color="code-red"
      title={
        <>
          {personalizationRequiredItems.length}{' '}
          {pluralize('item', personalizationRequiredItems.length)} in your Shopping Bag{' '}
          {pluralize('requires', personalizationRequiredItems.length)} personalization. Please edit
          or remove before proceeding.
        </>
      }
      onClose={() => setPreference('personalizationRequiredNotifications', false)}
    />
  );
};
